export default {
  home: {
    label1: '中文',
    vip: '開通會員', // 开通会员
    Downloadquota: '下載額度', // 下载额度
    Downloadspeed: '下載加速', // 下载加速
    Cloudcapacity: '雲盤空間', // 云盘空间
    Cloudequity: '雲盤權益', // 云盘权益
    DownloadLimit: '今日下載額度', // 今日下载额度
    awelfarepoint: '福利點', // 福利点
    HelpCentre: '幫助中心', // 帮助中心
    AccountSettings: '賬號設置', // 账号设置
    Login: '登 錄', // 登录
    Signup: '註 冊', // 注册
    SignOut: '退出登錄', // 退出登录
    Premium: '開通會員', //开通会员
    PremiumTwo: '升級會員', //升级会员
    PremiumThree: '會員中心', //会员中心
  },
  news: {
    // 信息悬浮框模块
    All: '全部', // 全部
    SystemNotification: '系統通知', // 系统通知
    OfficialNews: '官方消息', // 官方消息
    ReadAll: '全部已讀', // 全部已读
    Nonews: '暫無消息', // 暂无消息
  },
   model:{
    mtext1:'本鏈接由網友：',//该链接由
    mtest2:'自行上傳，並不代表本站立場',//自行分享，并不代表本站立场
    report:'舉報',//举报
    redirectLink:'跳轉鏈接',//跳转链接
    mtest3:'點擊後將跳轉至外部網站',//点击后将跳转至外部网站
    mtest4:'此短鏈已被系統審核過濾或被分享者刪除，無法訪問',//该短链已被系统审核过滤或被分享者删除，无法访问
    mtest5:'參考資料：',//参考资料：
    mtest6:'如有疑問可訪問：',//如有疑问可访问：
    mtest7:'未搵到短鏈頁面，請檢查短鏈是否正確',//未找到短链页面，请检查短链是否正确
    mtest8:'《Feemoo内容审核机制公示》',//《Feemoo内容审核机制公示》
    mtest9:'《Feemoo幫助中心》',//《Feemoo帮助中心》
    mtest10: '登入後跳轉連結', //登录后跳转链接
    mtest11: '完成登入後按鈕將跳轉至外部網站', //完成登录点击将跳转至外部网站
    mtest12: '去小程序睇廣告後跳轉', //去小程序看广告后跳转
    mtest13: '按鈕後前往微信小程序觀看廣告後將跳轉至外部網站', //点击后前往微信小程序观看广告后将跳转至外部网站
    mtest14: '去APP睇廣告後跳轉', //去APP看广告后跳转
    mtest15: '按鈕後前往APP觀看廣告後將跳轉至外部網站', //点击后前往APP观看广告后将跳转至外部网站
    SharedLink:'分享嘅連結',//分享的链接
    UnlockLogin:'登入後解鎖',//登录后解锁
    Unlock:'解鎖',//解锁
    Open:'打開',//打开
    mtest16:'登入後去小程序睇廣告解鎖',//登录后去小程序看广告解锁
    mtest17:'去小程序睇廣告解鎖',//去小程序看广告解锁
    mtest18:'登入後去APP睇廣告解鎖',//登录后去APP看广告解锁
    mtest19:'去APP睇廣告解鎖',//去APP看广告解锁
    mtest20:'登入後點擊解鎖',//登录后点击解锁
    mtest21:'點擊解鎖獲取連結',//点击解锁获取链接
  },
  homeFirst: {
    Quicktools: '快捷功能', // 快捷功能
    Files: '文件',
    Share: '分享',
    Set: '合集',
    DeepSeek: 'DeepSeek',
    Unzip: '雲解壓',
    Transit: '雲轉存',
    Record: '下載歷史',
    Device: '設備管理',
    Collect: '收藏',
    Activity: '動態',
    MoreActivity: '查看更多動態',
    recycle: '回收站', // 回收站
    ShortLink: '短鏈', // 短链
    ThisMonth: '本月',
    LastMonths: '近三個月',
    DownloadLimit: '今日下載額度', // 今日下载额度
    Downloadspeed: '下載加速', // 下载加速
    awelfarepoint: '福利點', // 福利点
    welfare: '福利社',// 福利社
  },
}
